<template lang="pug">
  .modal.active
    .modal-overlay(@click='closeModal')
    .modal-container
      .modal-header
        button.btn.btn-clear.float-right(@click='closeModal')
        .modal-title.h5 Sign In / Register
      .modal-body
        .content
          blockquote.message.warning
            b We're in beta!
            |  Thanks for checking us out! This part of the site is currently under heavy development, and logging in won't let you do too much yet. Please follow us on Twitter <a href="https://twitter.com/nonprofiters">@Nonprofiters</a> or <a href="https://twitter.com/heyozramos">@HeyOzRamos</a> to keep tabs on this feature. Thanks!
      .modal-footer
        button.btn.btn-primary(@click='twitterLogin' :class='{loading: isLoading}') Twitter Sign In
</template>





<script>
  import firebase from '@/service/firebase'

  export default {
    name: 'modal-login',

    data () {
      return {
        isLoading: false
      }
    },

    methods: {
      closeModal () {
        this.$store.commit('toggleLoginModal')
      },

      twitterLogin () {
        let provider = new firebase.auth.TwitterAuthProvider()
        this.isLoading = true

        firebase.auth().signInWithPopup(provider)
          // @TODO Let's add a welcome message if result.additionalUserInfo.isNewUser
          // @TODO We should make stay connected opt-in: https://firebase.google.com/docs/auth/web/auth-state-persistence
          .then((result) => {
            this.$store.commit('setUser', result.user)
          })
          // @TODO Let's toast the error message (test by turning off connection or temp disabling authorized domains)
          .catch((err) => {
            console.error(err)
          })
          .then(() => {
            this.isLoading = false
            this.$store.commit('toggleLoginModal')
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modal/Login.vue